module.exports = __webpack_public_path__ + "img/sn.21c497e8.svg";